var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('div',{staticClass:"mt-4 d-flex align-items-start justify-content-between"},[_c('div',[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t('Planning')))])])]),_vm._v(" "),_c('b-card',{staticClass:"mt-4 shadow-sm"},[_c('operation-show-planning',{attrs:{"is-global-props":true}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-165192ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/planning/PlanningIndex.vue
// module id = Aw+u
// module chunks = 0